// Realistic, recognizable first-responder icons rendered inline in Leaflet divIcons.
// Drawn as SVG paths intended for a 24x24 viewBox.

// FIRE — A fire helmet front-view (with shield brim + crown) — instantly readable as fire service.
const FIRE_SVG = `
  <path d="M3 14c0-4.5 4-7 9-7s9 2.5 9 7v1H3v-1z" />
  <path d="M2 15h20v3H2z" />
  <path d="M11 8h2v4h-2z" fill="#FFFFFF" stroke="none"/>
  <circle cx="12" cy="11" r="1.2" fill="#FFFFFF" stroke="none"/>
`;

// EMS — Star of Life (6-pointed star with central rod-of-Asclepius) — the official EMS symbol.
const EMS_SVG = `
  <path d="M12 2v20" stroke-width="2.2"/>
  <path d="M3.4 7l17.2 10" stroke-width="2.2"/>
  <path d="M20.6 7L3.4 17" stroke-width="2.2"/>
  <circle cx="12" cy="12" r="2.3" fill="#FFFFFF" stroke="none"/>
  <path d="M12 9.8v4.4" stroke="#0984E3" stroke-width="0.8" fill="none"/>
`;

// POLICE — Shield with center 5-point star.
const POLICE_SVG = `
  <path d="M12 2.2l8.2 2.8v5.6c0 5.2-3.9 9.1-8.2 11.2C7.7 19.7 3.8 15.8 3.8 10.6V5L12 2.2z" />
  <path d="M12 7.3l1.1 3.4h3.6l-2.9 2.1 1.1 3.4L12 14.1l-2.9 2.1 1.1-3.4-2.9-2.1h3.6z" fill="#FFD700" stroke="#FFD700" stroke-width="0.6"/>
`;

// WEATHER — Storm cloud with lightning bolt.
const WEATHER_SVG = `
  <path d="M6 13a4 4 0 0 1 7.8-1.2A3.2 3.2 0 1 1 16.5 17H7.5A3.5 3.5 0 0 1 6 13z" />
  <path d="M11.5 14l-2.2 4h2.2l-1.1 4 3.6-5h-2.2l1.4-3z" fill="#FFD700" stroke="#FFD700" stroke-width="0.4"/>
`;

const BRANCH_SVG = {
  FIRE: FIRE_SVG,
  EMS: EMS_SVG,
  PD: POLICE_SVG,
  POLICE: POLICE_SVG,
  WEATHER: WEATHER_SVG,
};

const BRANCH_TO_COLOR = {
  FIRE: "#EE352E",
  EMS: "#00B894",
  PD: "#0984E3",
  POLICE: "#0984E3",
  WEATHER: "#FDCB6E",
};

function normBranch(b) {
  const x = (b || "POLICE").toUpperCase();
  return x === "PD" ? "POLICE" : x;
}

export function branchIconSvg(branch, color = "#fff", size = 20) {
  const b = normBranch(branch);
  const path = BRANCH_SVG[b] || POLICE_SVG;
  return `<svg viewBox="0 0 24 24" width="${size}" height="${size}" fill="${color}" stroke="${color}" stroke-width="0.6" stroke-linejoin="round" stroke-linecap="round">${path}</svg>`;
}

export function branchColor(branch) {
  return BRANCH_TO_COLOR[normBranch(branch)] || "#0984E3";
}

// Pin-style marker: colored teardrop pin with a white inner circle holding the realistic icon.
export function incidentMarkerHtml(branch, priorityColorVal = "#888", selected = false) {
  const bg = branchColor(branch);
  const svg = branchIconSvg(branch, bg, 18);
  const ring = selected ? "#facc15" : priorityColorVal;
  const ringPulse = selected ? "0 0 14px rgba(250,204,21,0.9)" : `0 0 8px ${ring}`;
  return `<div style="position:relative; width:38px; height:46px; display:flex; align-items:flex-start; justify-content:center;">
    <svg width="38" height="46" viewBox="0 0 38 46" style="position:absolute; inset:0; filter: drop-shadow(0 2px 3px rgba(0,0,0,0.55));">
      <path d="M19 1 C9 1 2 9 2 18 C2 28 13 38 19 45 C25 38 36 28 36 18 C36 9 29 1 19 1 Z"
            fill="${bg}" stroke="${ring}" stroke-width="2"
            style="filter: drop-shadow(${ringPulse});"/>
      <circle cx="19" cy="18" r="13" fill="#FFFFFF" stroke="${bg}" stroke-width="1"/>
    </svg>
    <div style="position:absolute; top:6px; left:0; right:0; display:flex; justify-content:center; pointer-events:none;">
      ${svg}
    </div>
  </div>`;
}
